import { useState } from "react";
import { IonGrid, IonRow, IonCard } from "@ionic/react";
import { PageTitle } from "./PageTitle";

export const FrameArrayRender = (props) => {
  const { data, pageTitle } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <IonGrid>
      <PageTitle pageTitle={pageTitle} />
      <IonRow className="inner-container">
        {data &&
          data.map((obj, idx) => (
            <IonCard key={idx} className="release-card transparent">
              <div className="frame-box">
                {/* Показать skeleton loader, если не загружено */}
                {!isLoaded && <div className="skeleton-loader"></div>}

                {/* Скрыть iframe, пока не загрузится */}
                <iframe
                  src={obj?.src}
                  loading="eager"
                  decoding="async"
                  fetchpriority="high"
                  title="bc-player"
                  style={{
                    border: 0,
                    width: "18rem",
                    height: "18rem",
                    display: isLoaded ? "block" : "none", // iframe виден только после загрузки
                  }}
                  frameBorder="0"
                  onLoad={() => setIsLoaded(true)} // Скрыть skeleton loader после загрузки
                />
              </div>
              <div className="card-footer">
                <IonRow>{obj?.name}</IonRow>
                <IonRow>{obj?.artist}</IonRow>
                <IonRow>{obj?.country}</IonRow>
              </div>
            </IonCard>
          ))}
      </IonRow>
    </IonGrid>
  );
};
